import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import * as React from 'react';
import S from './RichText.styles';
const RichText = (props) => {
    if (!props.content) {
        return null;
    }
    return (React.createElement(S.Container, { "data-layout": props.layout ?? 'default', "data-type": props.type ?? ContentType.Default, background: props.variant, translations: props.translations },
        props.title && React.createElement(S.Title, null, props.title),
        React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } })));
};
export default RichText;
